<mbs-button [isCtrl]="true"
            (click)="handleRestorePassword()">{{ 'shared:pass-recovery.forgotPassword' | i18next: { format: 'title' } }}</mbs-button>

<ng-template #versionUnsupportedModal>
  <p>{{ 'shared:pass-recovery.version_must_be' | i18next }}</p>
</ng-template>
